
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { BadgeIndianRupee } from 'lucide-react';

const CreditsCard = () => {
  // This would typically come from an API/database
  const availableCredits = 1000;

  return (
    <Card className="bg-gradient-to-br from-[#9E7C47]/20 to-[#9E7C47]/5 border-[#9E7C47]/30">
      <CardContent className="p-6">
        <div className="flex items-start gap-4">
          <div className="h-12 w-12 rounded-full bg-[#9E7C47]/20 flex items-center justify-center">
            <BadgeIndianRupee className="h-6 w-6 text-[#9E7C47]" />
          </div>
          <div>
            <h2 className="text-lg font-medium text-white/70">Available Investment Credits</h2>
            <div className="flex items-baseline mt-1">
              <span className="text-3xl font-bold text-[#9E7C47]">₹{availableCredits.toLocaleString()}</span>
              <span className="ml-2 text-sm text-white/50">for investments</span>
            </div>
            <p className="mt-2 text-sm text-white/70">
              Use these credits to start your investment journey!
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default CreditsCard;
